import { atom } from "recoil";

export const formFlowAtom = atom<number>({
  key: "formFlowAtom",
  default: 0,
});
